/**
 * Singleton AudioContext for the application.
 *
 * Extracted into a leaf module so that both recorder.js and policy modules
 * (localAsrEnablement.js) can read the sample rate without one importing the
 * other's side effects. This module does not register listeners, parse URL
 * params, or throw on missing Web Audio (the recorder handles that gating).
 *
 * AudioContext.sampleRate is fixed at construction time (per W3C spec), so
 * importing this module from localAsrEnablement gives the correct rate at
 * first evaluation — no setter or push pattern needed.
 *
 * Safe to import in non-DOM environments (Node tests, workers): returns null
 * when window/AudioContext is unavailable.
 */

const w = typeof window !== 'undefined' ? window : null;
const AudioContextCtor = w && (w.AudioContext || w.webkitAudioContext);

let ctx = null;
export let constructionError = null;
try {
  ctx = AudioContextCtor ? new AudioContextCtor() : null;
} catch (err) {
  // Construction can fail (per-document context limit, hardened browsers).
  // Degrade to null: recorder.js raises the user-facing error, and the local
  // ASR gate fails open rather than mislabelling this as lowSampleRate.
  constructionError = err;
  ctx = null;
}
export const globalContext = ctx;
